import axios from '@/libs/axios';

export default {
  async marketplaces() {
    const res = await axios.get('/marketplaces');
    return res;
  },

  async marketplace(id) {
    const res = await axios.get(`/marketplaces/${id}`);
    return res;
  },

  async marketplaceProjects(id = 1, isBuyer = true) {
    let res = null;
    if (id === -100) {
      res = await axios.get(`/marketplace-projects?per-page=1000&user=${isBuyer ? 'buyer' : 'seller'}`);
      return res;
    }
    res = await axios.get(`/marketplace-projects?per-page=1000&marketplace_id=${id}&user=${isBuyer ? 'buyer' : 'seller'}`);
    return res;
  },

  async createMarketplaceProject(data) {
    const res = await axios.post('/marketplace-projects', data);
    return res;
  },

  async getMarketplaceProject(projectSlug, isBuyer = true) {
    const res = await axios.get(`/marketplace-projects/${projectSlug}?user=${isBuyer ? 'buyer' : 'seller'}`);
    return res;
  },

  async updateMarketplaceProject(id, data) {
    const res = await axios.put(`/marketplace-projects/${id}`, data);
    return res;
  },

  async deleteMarketplaceProject(id) {
    const res = await axios.delete(`/marketplace-projects/${id}`);
    return res;
  },

  async getAllMarketplaceOffers(isBuyer = true, query = {}) {
    const res = await axios.get(`/marketplace-offers?user=${isBuyer ? 'buyer' : 'seller'}`, {
      params: query,
    });
    return res;
  },

  async projectOffers(projectId, isBuyer = true) {
    const res = await axios.get(`/marketplace-offers?project_id=${projectId}&user=${isBuyer ? 'buyer' : 'seller'}`);
    return res;
  },

  async createOffer(data) {
    const res = await axios.post('/marketplace-offers', data);
    return res;
  },

  async getOffer(offerId) {
    const res = await axios.get(`/marketplace-offers/${offerId}`);
    return res;
  },

  async updateOffer(offerId, data) {
    const res = await axios.put(`/marketplace-offers/${offerId}`, data);
    return res;
  },

  async deleteOffer(offerId) {
    const res = await axios.delete(`/marketplace-offers/${offerId}`);
    return res;
  },

  async marketplacesStatistics(isBuyer = true, query = {}) {
    const res = await axios.get(`/marketplaces/user?user=${isBuyer ? 'buyer' : 'seller'}`, {
      params: query,
    });
    return res;
  },

  async marketplaceOfferMessage(data) {
    const res = await axios.post('/marketplace-offers/message', data);
    return res;
  },

  async marketplaceProjectMessage(data) {
    const res = await axios.post('/marketplace-projects/message', data);
    return res;
  },

  async changeOfferStatus(payload) {
    const res = await axios.put('/marketplace-offers/status', payload);
    return res;
  },

  async uploadFile(id, data) {
    const res = await axios.post(`/media/marketplace_project/${id}`, data);
    return res;
  },

  async removeFile(id, data) {
    const res = await axios.delete(`/media/marketplace_project/${id}`, { data });
    return res;
  },

  async offerUploadFile(id, data) {
    const res = await axios.post(`/media/marketplace_offer/${id}`, data);
    return res;
  },

  async offerRemoveFile(id, data) {
    const res = await axios.delete(`/media/marketplace_offer/${id}`, { data });
    return res;
  },

  async sellerSaveProject(data) {
    const res = await axios.post('/marketplaces/user', data);
    return res;
  },

  async sellerUnsaveProject(data) {
    const res = await axios.delete('/marketplaces/user', { data });
    return res;
  },

  async saveProduct(productId) {
    const res = await axios.post('/marketplaces/user', { product_id: productId });
    return res;
  },

  async unsaveProduct(productId) {
    const res = await axios.delete('/marketplaces/user', { data: { product_id: productId } });
    return res;
  },

  async addLikeToMessage(messageId) {
    const res = await axios.post(`/likes/posts/${messageId}`);
    return res;
  },

  async removeLikeFromMessage(messageId) {
    const res = await axios.delete(`/likes/posts/${messageId}`);
    return res;
  },

  async marketplaceProducts(query = {}) {
    const res = await axios.get('/marketplace-products', { params: query });
    return res;
  },

  async marketplaceProduct(productID) {
    const res = await axios.get(`/marketplace-products/${productID}`);
    return res;
  },

  async markMarketplaceProductMessagesRead(productId, messageIds) {
    const res = await axios.post(`/marketplace-products/${productId}/messages/read`, {
      message_ids: messageIds,
    });
    return res;
  },

  async markMarketplaceProductOfferMessagesRead(offerId, messageIds) {
    const res = await axios.post(`/marketplace-product-offers/${offerId}/messages/read`, {
      message_ids: messageIds,
    });
    return res;
  },

  async markMarketplaceProductOffersRead(productId, offerIds) {
    const res = await axios.post(`/marketplace-products/${productId}/offers/read`, {
      offer_ids: offerIds,
    });
    return res;
  },

  async createMarketplaceProduct(payload) {
    const res = await axios.post('/marketplace-products', payload);
    return res;
  },

  async updateMarketplaceProduct(productID, payload) {
    const res = await axios.put(`/marketplace-products/${productID}`, payload);
    return res;
  },

  async deleteMarketplaceProduct(productID) {
    const res = await axios.delete(`/marketplace-products/${productID}`);
    return res;
  },

  async marketplaceProductMessage(payload) {
    const res = await axios.post('/marketplace-products/message', payload);
    return res;
  },

  async getMarketplaceProductOffer(offerId) {
    const res = await axios.get(`/marketplace-product-offers/${offerId}`, {
      params: {
        offer_id: offerId,
      },
    });
    return res;
  },

  async marketplaceProductOffers(offerId) {
    return this.getMarketplaceProductOffer(offerId);
  },

  async createMarketplaceProductOffer(payload) {
    const res = await axios.post('/marketplace-product-offers', payload);
    return res;
  },

  async marketplaceProductOfferMessage(payload) {
    const res = await axios.post('/marketplace-product-offers/message', payload);
    return res;
  },

  async changeProductOfferStatus(payload) {
    const res = await axios.put('/marketplace-product-offers/status', payload);
    return res;
  },

  async marketplaceProductSubscriptions(query = {}) {
    const res = await axios.get('/marketplace-product-subscriptions', { params: query });
    return res;
  },

  async createMarketplaceProductSubscription(payload) {
    const res = await axios.post('/marketplace-product-subscriptions/create', payload);
    return res;
  },

  async updateMarketplaceProductSubscription(payload) {
    const res = await axios.put('/marketplace-product-subscriptions/update', payload, {
      params: {
        id: payload?.id,
      },
    });
    return res;
  },

  async deleteMarketplaceProductSubscription(subscriptionId) {
    const res = await axios.delete(`/marketplace-product-subscriptions/${subscriptionId}`);
    return res;
  },

  async marketplaceProjectSubscriptions(query = {}) {
    const res = await axios.get('/marketplace-project-subscriptions', { params: query });
    return res;
  },

  async createMarketplaceProjectSubscription(payload) {
    const res = await axios.post('/marketplace-project-subscriptions/create', payload);
    return res;
  },

  async updateMarketplaceProjectSubscription(payload) {
    const res = await axios.put('/marketplace-project-subscriptions/update', payload, {
      params: {
        id: payload?.id,
      },
    });
    return res;
  },

  async deleteMarketplaceProjectSubscription(subscriptionId) {
    const res = await axios.delete(`/marketplace-project-subscriptions/${subscriptionId}`);
    return res;
  },
};
